module.exports = __webpack_public_path__ + "media/icons/grid2-f61e5d0d.png";